import(/* webpackMode: "eager", webpackExports: ["IntegrationsGrid"] */ "/tmp/8de65d622e98acb/components/sections/IntegrationsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/node_modules/next/dist/client/link.js");
